import { WelcomeOfferBonusType } from './WelcomeOfferBonusType';

export enum WelcomeBonusKind {
    Comtrade = 'Comtrade',
    Betler = 'Betler',
}

export type WelcomeBonusUsage = {
    name: string;
    award: string;
    description: WelcomeBonusDescription;
};

export type WelcomeBonusDescription = {
    title: string;
    conditions: string[];
};

interface WelcomeBonusBase {
    kind: WelcomeBonusKind;
    id: number;
    title: string;
    description: string;
    image: string;
    type: WelcomeOfferBonusType;
}

export interface ComtradeWelcomeBonus extends WelcomeBonusBase {
    code: string;
    staticUrl: string | null;
}

export interface BetlerWelcomeBonus extends Omit<WelcomeBonusBase, 'id'> {
    id: string;
    buttonText: string;
    usage?: WelcomeBonusUsage[];
    cardTitle?: string;
    shortDescription?: string;
    longDescription?: string;
    bonusExplanation?: string;
}

export type WelcomeBonus = ComtradeWelcomeBonus | BetlerWelcomeBonus;

export type WelcomeBonusResponse = {
    welcomeOfferCampaignId: string | null;
    availableBonuses: WelcomeBonus[];
};
